import { Component } from '@angular/core';
import { STATES_POLICY, POLICY_DOCUMENT_URLS } from '@constants/embrace-policy-states';
import STATES from '@constants/state-list.json';

@Component({
	selector: 'qe-embrace-policy-modal',
	templateUrl: './embrace-policy-modal.component.html',
	styleUrls: ['./embrace-policy-modal.component.scss'],
})
export class EmbracePolicyModalComponent {
	public states: Array<{ name: string; abbreviation: string }> = STATES;
	public downloadLink: string = '';
	public isColorMatch: boolean = false;

	constructor() {
		// checks if brandPimary == brandAccent, if so, we add 'white-text' class to
		// 'embrace-policy__download-button' class, this assumes the color is dark
		// and therefore we need to show white text for the button
		const element = document.getElementsByTagName('body')[0];
		if (element) {
			const styles = getComputedStyle(element);
			const brandPrimary = styles.getPropertyValue('--brandPrimary');
			const brandAccent = styles.getPropertyValue('--brandAccent');

			if (brandPrimary === brandAccent) {
				this.isColorMatch = true;
			}
		}
	}

	public handleEpiSelectionChange(el: Event): void {
		const element = el.target as HTMLSelectElement;

		this.downloadLink = POLICY_DOCUMENT_URLS[
			STATES_POLICY[element.value as keyof typeof STATES_POLICY] as keyof typeof POLICY_DOCUMENT_URLS ||
			STATES_POLICY.OTHER as keyof typeof POLICY_DOCUMENT_URLS
		];
	}
}
